import React, { useState, useEffect } from 'react'
import { Link, NavLink } from 'react-router-dom'
import './Header.css'

const links = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Services' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
 { to: '/team', label: 'Team' },
  { to: '/reviews', label: 'Reviews' },
]

const Header = () => {

  const [open, setOpen] = useState(false)

  const toggle = () => setOpen((s) => !s)

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape' && open) setOpen(false)
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open])

  // prevent body scroll when menu is open on mobile
  useEffect(() => {
    document.body.classList.toggle('no-scroll', open)
    return () => document.body.classList.remove('no-scroll')
  }, [open])

  return (
    <>
      <header className="site-header">
        <Link to="/"  className='log'>

          <div className="logo-box">
            <img
              src="https://res.cloudinary.com/di82vlbpn/image/upload/v1764964487/ChatGPT_Image_Dec_6_2025_01_23_40_AM_i8bd26.png"
              alt="Logo"
              className="logo-img"
            />
            <h2 className="brand">Star Aluminium Works</h2>
          </div>
          </Link>

          <nav id="main-nav" className={`nav ${open ? 'open' : ''}`} aria-label="Main navigation" aria-hidden={!open && window.innerWidth <= 880}>
            <button className="nav-close" onClick={() => setOpen(false)} aria-label="Close menu">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                <path d="M18 6L6 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>

            <ul className="nav-links">
              {links.map((l) => (
                <li key={l.to}>
                  <NavLink
                    to={l.to}
                    end={l.to === '/'}
                    className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}
                    onClick={() => setOpen(false)}
                  >
                    {l.label}
                  </NavLink>
                </li>
              ))}
            </ul>

            <div className="cta">
          
          
            </div>
          </nav>

          <button
            className={`burger ${open ? 'open' : ''}`}
            onClick={toggle}
            aria-expanded={open}
            aria-controls="main-nav"
            aria-label={open ? 'Close menu' : 'Open menu'}
          >
            {open ? (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                <path d="M18 6L6 18" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6 6L18 18" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            ) : (
              <svg width="22" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                <path d="M3 6H21" stroke="white" strokeWidth="2.2" strokeLinecap="round" />
                <path d="M3 12H21" stroke="white" strokeWidth="2.2" strokeLinecap="round" />
                <path d="M3 18H21" stroke="white" strokeWidth="2.2" strokeLinecap="round" />
              </svg>
            )}
          </button>
      </header>

      <div className={`overlay ${open ? 'show' : ''}`} onClick={() => setOpen(false)} aria-hidden={!open} />
    </>
  )
}

export default Header
